import noImage from "../../assets/no-image.jpeg";

// Some legacy records stored the URL wrapped in stray quote characters
// (e.g. '"https://.../logo.png"'), which breaks the <img> src. Strip any
// surrounding quotes/whitespace so the image still renders.
const sanitizeUrl = (url) =>
  typeof url === "string" ? url.trim().replace(/^["']+|["']+$/g, "") : url;

export const ImageView = ({ label, value = "" }) => {
  value = sanitizeUrl(value);
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      {value ? (
        <div className="w-[10rem] h-[10rem] my-1 rounded-lg">
          <img
            src={value}
            className="w-full h-full rounded-lg object-cover"
            alt={`${label}-image`}
          />
        </div>
      ) : (
        <div className="w-[10rem] h-[10rem] my-1 rounded-lg overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export const DocumentView = ({ label, value = "" }) => {
  value = sanitizeUrl(value);
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      {value ? (
        <div className="h-auto w-full max-w-[350px] my-1 rounded-lg">
          <img
            src={value}
            className="w-full h-full rounded-lg object-contain"
            alt={`${label}-image`}
          />
        </div>
      ) : (
        <div className="h-[14rem] w-full max-w-[350px] my-1 rounded-lg overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export const DocumentAltView = ({ label, value = { url: "", alt: "" } }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      {value?.url ? (
        <div className="h-auto w-full max-w-[350px] my-1 rounded-lg">
          <img
            src={value.url}
            className="w-full h-full rounded-lg object-cover"
            alt={`${value.alt ?? value.url}`}
          />
        </div>
      ) : (
        <div className="h-[14rem] w-full max-w-[350px] my-1 rounded-lg overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

export const ImageViewArray = ({ label, value = [] }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      <div className="flex flex-wrap gap-5 items-center">
        {value?.map((item, index) => (
          <div key={index} className="w-[10rem] h-[10rem] my-1 rounded-lg">
            <img
              src={item}
              className="w-full h-full rounded-lg"
              alt={`${label}-image`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const VideoView = ({ label, value = "" }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>

      {value ? (
        <div>
          <div className="flex items-center justify-between rounded p-1">
            <p className="text-fs_14 truncate">{value.name}</p>
          </div>
          <div className="h-auto w-full max-w-[350px] my-1 rounded-lg overflow-hidden bg-black">
            <video
              src={value?.url}
              controls
              className="w-full h-full object-cover rounded-lg"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      ) : (
        <div className="w-[10rem] h-[10rem] my-1 rounded-lg overflow-hidden bg-black flex items-center justify-center">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};
